import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAISecond/components/Title';
import { PaywallAppSteps } from '@/pages/Paywall/components/AppStep';

import { HowItWorksStyles } from './HowItWorks.styles';

export const SectionHowItWorks: React.FC = () => {
  return (
    <HowItWorksStyles>
      <OwnAiTitle className="how-it-works-title">
        How it{' '}
        <UiTypography variant="inherit" component="span" color="gradient">
          works
        </UiTypography>
      </OwnAiTitle>

      <PaywallAppSteps />
    </HowItWorksStyles>
  );
};
